import React, { Component } from 'react';
import SwipeHandler from './SwipeHandler.js'
import InteractionMask from './InteractionMask'
import DragVideo from './DragVideo'
import InteractionPendules from './InteractionPendules'
import SwirleVideo from './SwirleVideo'
import Helper from './Helper'

import './Interaction.css';


class Interaction extends Component {

    constructor(props) {

        super(props);     
        
        this.state = {
            helper_exit : false,
            pendule1_show: true,
            pendule2_show: true,
        }
        
    }

    shouldComponentUpdate(nextProps, nextState)
    {
        const interaction = window.g_CONFIG_UI.interactions[nextProps.id];
        if(interaction)
            return true;
        else
            return false;
    }    

    /* AFTER SWIPE */
    onAnimFrameSwipe = (dx,dy) =>
    {
        /* NOT USED */
        this.props.logFn("Interaction:onAnimFrame : "+dx+" "+dy);
    }    

    render() {

        const {onEnd, id, logFn, menuOpen}  = this.props;

        const interaction = window.g_CONFIG_UI.interactions[id];
        if(!interaction)  logFn("  App:Interaction() >> ERROR "+id+" NOT FOUND !!!");
      
        let style_touch = {};
        let it = 'tap'; // default, devra être remplacé 
        if(interaction.type !== undefined)
        {
          it = interaction.type;
            
          if( interaction.x === undefined)  /* si pas de config */
          {
            // centrera automatiquement la zone de touch
            style_touch.width = "13%";
            style_touch.height = "24%";
            style_touch.rot = '0deg';
          }else 
          {
            style_touch.left = interaction.x+"%";
            style_touch.top = interaction.y+"%";
            style_touch.width = interaction.w+"%";
            style_touch.height = interaction.h+"%";
            style_touch.rot = interaction.r+'deg';
          }        
        }else logFn("  App:Interaction() >> ERROR type NOT DEFINED !!!");


        let cl = 'interaction_zone_touch';
        if(window._DEBUG_TOUCH) cl += ' debugTouch ';                

        switch(it){
        /* ces interactions suivantes apparaissent sur la vidéo */
        case 'tap':
            return( <div className="interaction">
                    <Helper helper={ it } s={ style_touch } ></Helper>
                    <div className={ cl } style= { style_touch } onClick={onEnd} ></div> 
                </div>);
        case 'swipe_left':
        case 'swipe_right':
        case 'swipe_up':
        case 'swipe_down':
            return( <div className="interaction">
                    <Helper helper={ it } s={ style_touch } ></Helper>
                    <SwipeHandler swipeNeed={ it } onAnimFrame={ this.onAnimFrameSwipe } logFn= { logFn } onEnd={ onEnd }>
                        <div className={ cl } style= { style_touch } ></div> 
                    </SwipeHandler>
                    </div> );
        /* les interactions suivantes masquent sur la vidéo */
        case 'mask-c07':
            return(<InteractionMask logFn={ this.props.logFn } onEnd={ onEnd } scale={ this.props.scale } sizePoint='50' menuOpen={ menuOpen } backgroundImage='./interactifs/CH07/background.jpg' foregroundImage='./interactifs/CH07/foreground.png'>
                        <Helper helper={ it } s={ style_touch } ></Helper>
                    </InteractionMask>);
        case 'mask-c11':
            return(<InteractionMask logFn={ this.props.logFn } onEnd={ onEnd } scale={ this.props.scale } sizePoint='100' menuOpen={ menuOpen } backgroundImage='./interactifs/CH11/background.jpg' foregroundImage='./interactifs/CH11/foreground.png'>
                            <Helper helper={ it } s={ style_touch } ></Helper>
                    </InteractionMask>);                        
        case 'drag_video-13':
            return( <DragVideo logFn={ this.props.logFn } onEnd={ this.onDragEnd } menuOpen={ menuOpen } scale={ this.props.scale }  video='./videos/CH02/13/C13.mp4' touchZone={ interaction } callBackSendPosition={ this.props.callBackSendPosition} >
                        <Helper helper={ it } s={ style_touch } ></Helper>
                        { this.state.helper_exit }
                    </DragVideo>);
        case 'pendules-15' :
            return( <InteractionPendules logFn={ this.props.logFn } scale={ this.props.scale } menuOpen={ menuOpen } onEnd={ onEnd } onHideHelper1 = { () => { this.setState( { pendule1_show: false }); } } onHideHelper2 = { () => { this.setState( { pendule2_show: false }); } } >
                        { this.state.pendule1_show && <Helper helper='pendule-15a' s={ style_touch } ></Helper> }
                        { this.state.pendule2_show && <Helper helper='pendule-15b' s={ style_touch } ></Helper> }
                    </InteractionPendules>);
        case 'swirle-18':
            return( <SwirleVideo logFn={ this.props.logFn } onEnd={ onEnd } menuOpen={ menuOpen } scale={ this.props.scale } video='./videos/CH02/18/C18.mp4' touchZone={ interaction } >
                        <Helper helper={ it } s={ style_touch } ></Helper>
                    </SwirleVideo>);
        case 'drag_video-21':
            return( <DragVideo logFn={ this.props.logFn } onEnd={ this.onDragEnd } menuOpen={ menuOpen } scale={ this.props.scale } video='./videos/CH03/21/C21.mp4' touchZone={ interaction } callBackSendPosition={ this.props.callBackSendPosition} >
                         <Helper helper={ it } s={ style_touch } ></Helper>
                         { this.state.helper_exit }
                    </DragVideo> );
                
        default:
            this.props.logFn("Interaction:render : !!!! ERROR unknow type !!!!");
        }

  }

  onDragEnd = () =>
  {
    /* cas particulier du dragVideo : on rajoute un helper à la fin, et l'action sur ce helper sort via onend() */

    //const {onEnd, id, logFn} = this.props;

    let cl = 'interaction_zone_touch';
    if(window._DEBUG_TOUCH) cl += ' debugTouch ';            

    this.props.logFn("Interaction:onDragEnd()");

    let contenu =   <React.Fragment>
                        <Helper helper="swipe_left" s={ { left: '70%', top: '0%', width:'30%', height:'24%' } }></Helper>
                        <SwipeHandler swipeNeed="swipe_left"  onAnimFrame={ this.onAnimFrameSwipe } logFn= { this.props.logFn } onEnd={ this.props.onEnd }>
                            <div className={ cl } style= { { left: '70%', top: '0%', width:'30%', height:'24%' } } ></div> 
                        </SwipeHandler>
                    </React.Fragment>

    this.setState( { helper_exit: contenu });

  }
  
}




//----------------------------------------------------------------------------

export default Interaction;



// WEBPACK FOOTER //
// ./src/Interaction.js